import ViewBase from "../../view-base.view";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import MultiSelectComponent from "../../../components/multi-select/multi-select.component";
import codeMasterModel from "../../../models/common/code-master.model";
import { getAvailableRecipients, saveRandomPing } from "../../../models/announcement/randomPing.model"
import DateTimePickerComponent from '../../../components/date-picker/DateTimePicker';
import moment from "moment";
import ResultDialog from './randomPing-add-result.dialog'
import { Dialog  } from 'construct-ui';

export default function AddRandomPingView(vnode) {
  ViewBase.call(this);

  let pingTypes = [];
  let recipientList = [];
  let isResultDialogOpen = false;
  let resultList = [];

  const inputDataModel = {
    title: "",
    recipients: [],
    pingType: {},
    clientStartTime: '',
  };

  const fetchAvailableRecipients = () => {
    this.showLoading();
    let params = {
      pingType: inputDataModel.pingType.name,
      pageIndex: 1,
      pageSize: 300
    }
    if (params.pingType === 'Schedule') {
      const timeZoneInt = Math.round(moment().utcOffset() / 60)
      params = Object.assign(params, {scheduleDate: moment(inputDataModel.clientStartTime).format("YYYY-MM-DD HH:mm:ss:SSS"), timeZone: timeZoneInt,})
    }
    getAvailableRecipients(params)
      .then(result => {
        recipientList = result.data?.map((x) => ({code: x.userId, name: x.userName}))
      })
      .catch(error => {
        this.handleError(error)
      }).finally((error) => {
        this.hideLoading();
      })
  }

  const getPingTypes = () => {
    codeMasterModel.getByCategoryV2({ category: 'PingType' })
      .then(result => {
        pingTypes = result;
      })
      .catch(error => {
        this.handleError(error)
      })
  }

  const handleSave = (e) => {
    if (!this.validateForm(e, "#addRandomPing")) {
      return false;
    } else {
      let paramsObj = {
        title: inputDataModel.title,
        pingType: inputDataModel.pingType.name,
        recipients: inputDataModel.recipients.join("^"),
        clientStartTime: moment(new Date(), moment.ISO_8601),
        timeZone: 0
      };
      if (paramsObj.pingType === 'Schedule') {
        const timeZoneInt = Math.round(moment().utcOffset() / 60);
        paramsObj = Object.assign(paramsObj, {clientStartTime: moment(inputDataModel.clientStartTime, moment.ISO_8601), timeZone: timeZoneInt,})
      }
      saveRandomPing(paramsObj).then((result) => {
        openDialog(result);
      }).catch((error) => {
        this.handleError(error);
      })
    }
  }

  const handleCancel = (e) => {
    vnode.attrs.onClose?.(e);
  }

  const openDialog = (result) => {
    resultList = result;
    isResultDialogOpen = true;
  }

  const closeDialog = () => {
    isResultDialogOpen = false;
    vnode.attrs.onSave?.(resultList);
  }

  return {
    oninit: (vnode) => {
      getPingTypes();
    },
    view: (vnode) => {
      return [
        m("form#addRandomPing.card-body.needs-validation[novalidate]", { onsubmit: handleSave },
          m('.mt-2.position-relative',
            m("label.form-label.mandatory[for='pingTitle']",
              this.getText("LT00000037", "Title")
            ),
            m('input#pingTitle', {
              required: true,
              class: 'form-control form-control-bg',
              placeholder: this.getText("LT00000037", "Title"),
              type: 'text',
              value: inputDataModel.title,
              onchange: (e) => { inputDataModel.title = e.target.value }
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          m(".mt-2.position-relative",
            m("label.form-label.mandatory[for='pingType']",
              this.getText("LT00008153", "Ping Type")
            ),
            m(SingleSelectComponent, {
              id: "pingType",
              items: pingTypes,
              allowEmpty: false,
              required: true,
              filterable: false,
              selectedItem: inputDataModel.pingType,
              onSelect: (s) => {
                inputDataModel.pingType = s;
              }
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          inputDataModel.pingType?.name === "Schedule" && m(".mt-2.position-relative",
            m("label.form-label.mandatory[for='scheduleTime']",
              this.getText("LT00000181", "Schedule Time")
            ),
            m(DateTimePickerComponent, {
              id: "scheduleTime",
              value: inputDataModel.clientStartTime,
              required: true,
              onchange: (e) => {
                console.log('EEEEEEEEEEE', e)
                inputDataModel.clientStartTime = e.datetime;
              }
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          m('.mt-2.position-relative',
            m('label.form-label.mandatory[for="recipients"]', this.getText("LT00000039", "Recipients")),
            m(MultiSelectComponent, {
              id: 'recipients',
              items: recipientList,
              selectedItems: inputDataModel.recipients,
              keyOnly: true,
              filterable: true,
              required: true,
              fetchData: () => {
                if ((inputDataModel.pingType?.name === "Schedule" && inputDataModel.clientStartTime) || inputDataModel.pingType.name === "Instant") {
                  if (recipientList.length > 0) {
                    console.log("using cached data!")
                  } else {
                    fetchAvailableRecipients()
                  }
                } else {
                  this.showMessage("Please select Ping Type or Schedule Time first!")
                }
              },
              onSelect: (v) => {
                inputDataModel.recipients = v;
              }
            }),
            m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
          ),
          m('.col-md-12.gap-2.mt-4.d-flex.justify-content-end',
            m('button.btn.btn-primary[type="submit"].px-4.gap-3', this.getText('LT00000022', "Save")),
            m(
              "button.btn.btn-white[type='button']", { onclick: handleCancel },
              this.getText("LT00000021", "Close")
            )
          )
        ),
        isResultDialogOpen &&
        m(Dialog, {
          isOpen: isResultDialogOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: closeDialog,
          title: "Result",
          content: m(ResultDialog, { onClose: closeDialog, resultList: resultList }),
          "class": "cui-dialog-xxl",
        }),
        this.getBaseViews()
      ];
    }
  }
}
